import { DndContext, DragOverlay } from '@dnd-kit/core';
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import { verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSmartSensors } from '@framework/engine';
import { ISortableWidgetEditorProps } from '@framework/engine/src/schema/widgets/ISortableWidgetEditorProps';
import { DeferredRender } from '@framework/ui';
import * as React from 'react';
import { useMemo } from 'react';
import { WidgetConfigDrawer } from '../widgets/WidgetConfigDrawer';
import { AddWidgetSelectInput } from './AddWidgetSelectInput';
import { SortableWidgetList } from './SortableWidgetList';
import { useDndEditor } from './hooks/useDndEditor';
import { DndEditorContext } from './hooks/useDndEditorContext';
import { DragOverlayContainer } from './sortable-widgets/DragOverlayContainer';
import { SortableWidgetRender } from './sortable-widgets/SortableWidgetRender';

/**
 * Componente root per la gestione del Sortable Drag&Drop dei widget.
 */
export function SortableWidgetEditor(props: ISortableWidgetEditorProps) {
  const editor = useDndEditor(props);
  const sensors = useSmartSensors();

  const contextValue = useMemo(() => ({ editor }), [editor]);

  return (
    <DndEditorContext.Provider value={contextValue}>
      <DndContext
        sensors={sensors}
        collisionDetection={editor.collisionDetection}
        onDragStart={editor.handleDragStart}
        onDragEnd={editor.handleDragEnd}
        onDragOver={editor.handleDragOver}
        onDragCancel={editor.handleDragCancel}
      >
        <DeferredRender>
          <div>
            <SortableWidgetList
              widgets={editor.root?.children ?? []}
              strategy={verticalListSortingStrategy}
            />
            <DragOverlay modifiers={[snapCenterToCursor]}>
              {editor.active && (
                <DragOverlayContainer>
                  <SortableWidgetRender widget={editor.active} isDragOverlay />
                </DragOverlayContainer>
              )}
            </DragOverlay>
          </div>
        </DeferredRender>
        <WidgetConfigDrawer />
      </DndContext>
      <AddWidgetSelectInput {...props} filter={props.availableWidgetFilter} />
    </DndEditorContext.Provider>
  );
}
